@if (item) {
  @if (compressed) {
    <ng-container (click)="selectIsinCompressed(item.isin)">
      <td>
        <div class="d-flex">
          <div class="text-align-left">{{ item.longName }}</div>
        </div>
      </td>
      @if (item.isin === selectedIsinCompressed) {
        <td class="text-align-center" colspan="2">
          <div class="d-flex justify-content-end">
            <div class="btn-icon cursor-pointer mr-3" (click)="removeItem.emit()" title="Entfernen">
              <svg class="icon icon-21">
                <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#bin" />
              </svg>
            </div>
            @if (!item.isEndfaellig && !item.isKnockedOut && !item.isSoldOut) {
              <div
                class="trade buy text-color-success cursor-pointer"
                title="Kaufen"
                [routerLink]="commonRoutes.postlogin.buyAndSell"
                [queryParams]="{
                  isin: item.isin,
                  direction: 'buy',
                }"
              >
                <svg class="icon icon-24">
                  <use xlink:href="/assets/img/svgs/svgset.svg#order" />
                </svg>
              </div>
            }
          </div>
        </td>
      }
      @if (item.isin !== selectedIsinCompressed && !item.isEndfaellig && !item.isKnockedOut) {
        <td>
          <div class="d-flex justify-content-end">
            @if (!item.bid) {
              <div class="text-color-primary">&mdash;</div>
            } @else {
              <div zeroBlink [val]="item.bid">
                {{ item.bid | currency: 'EUR' : 'symbol' : '1.2' }}
              </div>
            }
          </div>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            @if (performanceBasedOnEntry) {
              @if (item.perfPct !== undefined) {
                <div [ngClass]="item.perfPct >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
                  {{ item.perfPct | number: '1.2-2' }}&nbsp;%
                </div>
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            } @else {
              @if (item.dayBeforePct !== undefined) {
                <div [ngClass]="item.dayBeforePct >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
                  {{ item.dayBeforePct | number: '1.2-2' }}&nbsp;%
                </div>
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            }
          </div>
        </td>
      }
      @if (item.isin !== selectedIsinCompressed && (item.endfaellig || item.knockedOutFlag)) {
        <td colspan="2">
          <div class="d-flex justify-content-end">
            {{ item.knockedOutFlag ? ('watchlist.ko' | transloco) : ('watchlist.due' | transloco) }}
          </div>
        </td>
      }
    </ng-container>
  } @else {
    <td [class.ignore-opacity]="isCurrentlyEditing">
      <div class="d-flex">
        <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">{{ 'watchlist.labels.longName' | transloco }}</div>
        <div class="text-md-left text-right">
          <web-components-instrument-details-link class="font-medium" [isin]="item.isin">
            {{ item.longName }}
          </web-components-instrument-details-link>
        </div>
      </div>
      <ng-container>
        <div class="d-flex text-color-primary">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">{{ 'watchlist.labels.isin' | transloco }}</div>
          <span class="font-light">{{ item.type === isCrypto ? item.shortName : item.isin }}</span>
        </div>
      </ng-container>
    </td>
    <td [class.ignore-opacity]="isCurrentlyEditing">
      @if (!item.isEndfaellig && !item.isKnockedOut) {
        @if (!isCurrentlyEditing) {
          <div class="d-flex justify-content-end">
            <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">{{ 'watchlist.labels.ask' | transloco }}</div>
            @if (item.ask !== undefined) {
              <div zeroBlink [val]="item.ask">
                {{ item.ask | currency: 'EUR' : 'symbol' : '1.2' }}
              </div>
            } @else {
              <div class="text-color-primary">&mdash;</div>
            }
          </div>
        }
        <div class="d-flex justify-content-end">
          @if (isCurrentlyEditing) {
            <div class="editable-entry-quotes">
              <div class="d-flex justify-content-between">
                <div class="text-nowrap font-medium">angezeigter Kurs:</div>
                <div>
                  <input
                    #entryQuote
                    type="text"
                    inputmode="numeric"
                    [(ngModel)]="currentEntryQuote"
                    [class.error]="isEntryQuoteError"
                    class="max-w-100 text-right"
                  />
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between">
                <div tooltipclass="zero-tooltip" triggers="hover" placement="bottom" class="text-nowrap">bei zero hinterlegter Kurs:</div>
                <div class="ml-2">
                  {{ item.calcBase | currency: 'EUR' : 'symbol' : '1.2' }}
                </div>
              </div>
            </div>
          } @else {
            <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow text-align-left">
              {{ performanceBasedOnEntry ? ('watchlist.labels.entry' | transloco) : ('watchlist.labels.prev' | transloco) }}
            </div>
            @if (performanceBasedOnEntry) {
              @if (item.customEntryQuote !== undefined) {
                {{ item.customEntryQuote | currency: 'EUR' : 'symbol' : '1.2' }}
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            }
            @if (!performanceBasedOnEntry) {
              @if (item.prevDayQuote !== undefined) {
                {{ item.prevDayQuote | currency: 'EUR' : 'symbol' : '1.2' }}
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            }
          }
        </div>
        @if (isCurrentlyEditing) {
          <div class="d-flex justify-content-end align-items-center mt-2">
            <div>
              <a class="link-secondary cursor-pointer text-uppercase mr-4" (click)="updateEntryQuote.emit(item.calcBase)">
                {{ 'mydepot.depotoverview.positions.editable-entry-quotes.cancel' | transloco }}
              </a>
            </div>
            <div>
              <web-design-system-button size="small" (click)="validateEntryQuoteAndUpdate()">
                {{ 'mydepot.depotoverview.positions.editable-entry-quotes.save' | transloco }}
              </web-design-system-button>
            </div>
          </div>
        }
      }
    </td>
    <td>
      @if (!item.isEndfaellig && !item.isKnockedOut) {
        <div class="d-flex justify-content-end">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
            {{ 'watchlist.labels.perf' | transloco }}
          </div>
          @if (item.dayBeforePct !== undefined) {
            <div [ngClass]="item.dayBeforePct >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
              {{ item.dayBeforePct | number: '1.2-2' }}&nbsp;%
            </div>
          } @else {
            <div class="text-color-primary">&mdash;</div>
          }
        </div>
        <div class="d-flex justify-content-end">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
            {{ 'watchlist.labels.perfAbsolut' | transloco }}
          </div>
          @if (item.dayBeforeAbs !== undefined) {
            <div [ngClass]="item.dayBeforeAbs >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
              {{ item.dayBeforeAbs | currency }}
            </div>
          } @else {
            <div class="text-color-primary">&mdash;</div>
          }
        </div>
      }
      @if (item.isEndfaellig || item.isKnockedOut) {
        <div class="d-flex justify-content-end">
          <div class="text-color-primary">{{ 'watchlist.due' | transloco }}</div>
        </div>
      }
    </td>
    @if (performanceBasedOnEntry) {
      <td>
        @if (!item.isEndfaellig && !item.isKnockedOut) {
          <div class="d-flex justify-content-end">
            <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
              {{ 'watchlist.labels.perfPct' | transloco }}
            </div>
            @if (performanceBasedOnEntry) {
              @if (item.perfPct !== undefined) {
                <div [ngClass]="item.perfPct >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
                  {{ item.perfPct | number: '1.2-2' }}&nbsp;%
                </div>
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            } @else {
              @if (item.dayBeforePct !== undefined) {
                <div [ngClass]="item.dayBeforePct >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
                  {{ item.dayBeforePct | number: '1.2-2' }}&nbsp;%
                </div>
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            }
          </div>
          <div class="d-flex justify-content-end">
            <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
              {{ 'watchlist.labels.perfAbs' | transloco }}
            </div>
            @if (performanceBasedOnEntry) {
              @if (item.perfAbs !== undefined) {
                <div [ngClass]="item.perfAbs >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
                  {{ item.perfAbs | currency }}
                </div>
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            } @else {
              @if (item.dayBeforeAbs !== undefined) {
                <div [ngClass]="item.dayBeforeAbs >= 0 ? { 'text-color-success': true } : { 'text-color-error': true }">
                  {{ item.dayBeforeAbs | currency }}
                </div>
              } @else {
                <div class="text-color-primary">&mdash;</div>
              }
            }
          </div>
        }
        @if (item.isEndfaellig || item.isKnockedOut) {
          <div class="d-flex justify-content-end">
            <div class="text-color-primary">{{ 'watchlist.due' | transloco }}</div>
          </div>
        }
      </td>
    }
    <td>
      @if (!item.isEndfaellig && !item.isKnockedOut) {
        <div class="d-flex justify-content-end">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
            {{ 'watchlist.labels.quoteTime' | transloco }}
          </div>
          @if (item.quoteTime) {
            <div class="text-color-primary">
              {{ item.quoteTime | date: 'HH:mm:ss' }}
            </div>
          } @else {
            <div class="text-color-primary">&mdash;</div>
          }
        </div>
        <div class="d-flex justify-content-end">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
            {{ 'watchlist.labels.date' | transloco }}
          </div>
          @if (item.quoteTime) {
            <div class="text-color-primary">
              {{ item?.quoteTime | date: 'dd.MM.yy' }}
            </div>
          } @else {
            <div class="text-color-primary">&mdash;</div>
          }
        </div>
      }
      @if (item.isEndfaellig || item.isKnockedOut) {
        <div class="d-flex justify-content-end">
          <div class="text-color-primary">{{ 'watchlist.due' | transloco }}</div>
        </div>
      }
    </td>
    @if (!isEditEntryQuoteMode) {
      <td class="margin-xs-bottom-15 margin-sm-bottom-15">
        <div class="d-flex justify-content-end">
          <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow padding-top-10">&nbsp;</div>
          <div class="d-flex justify-content-end align-items-center">
            @if (!item.isEndfaellig && !item.isKnockedOut) {
              <div ngbDropdown class="d-inline-block" placement="bottom-right">
                <button
                  [disabled]="isCurrentlyAddTagMode"
                  class="btn-icon cursor-pointer mr-2"
                  id="dropdown"
                  ngbDropdownToggle
                  (click)="cancelTagMode.emit()"
                >
                  <svg class="icon icon-21 text-primary">
                    <use xlink:href="/assets/img/svgs/svgset.svg#dots" />
                  </svg>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdown" class="position-dropdown">
                  <button ngbDropdownItem (click)="editEntryQuote.emit()">
                    <svg class="icon icon-24 color-secondary mr-2">
                      <use xlink:href="/assets/img/svgs/svgset.svg#edit-pencil" />
                    </svg>
                    {{ 'watchlist.edit-entry' | transloco }}
                  </button>
                  <button ngbDropdownItem (click)="addTagMode.emit()" class="d-flex gap-half">
                    <web-design-system-icon name="tag" color="action" />
                    {{ 'watchlist.actions.add-tag' | transloco }}
                    <web-design-system-pill type="new">
                      {{ 'mydepot.depotoverview.positions.settings.newBadge' | transloco | uppercase }}
                    </web-design-system-pill>
                  </button>
                  <button ngbDropdownItem (click)="editNote.emit()">
                    <svg class="icon icon-24 color-secondary mr-2">
                      <use xlink:href="/assets/img/svgs/svgset.svg#edit-note" />
                    </svg>
                    {{ 'watchlist.add-note' | transloco }}
                  </button>
                  @if (item.isSavingsPlanEligible && (isPotentialCustomer$ | async) === false) {
                    <button data-zid="savings-plan-btn" ngbDropdownItem [routerLink]="[commonRoutes.postlogin.add_savings_plan, item.isin]">
                      <svg class="icon icon-24 color-secondary mr-2">
                        <use xlink:href="/assets/img/svgs/svgset.svg#pig" />
                      </svg>
                      {{ 'watchlist.actions.savings-plan' | transloco }}
                    </button>
                  }
                </div>
              </div>
            }
            <div class="btn-icon cursor-pointer mr-2" (click)="removeItem.emit()" [title]="'watchlist.actions.delete' | transloco">
              <svg class="icon icon-21">
                <use class="icon-trashcan" xlink:href="/assets/img/svgs/svgset.svg#bin" />
              </svg>
            </div>
            @if (!item.isSoldOut && !item.isKnockedOut && !item.isEndfaellig && (isPotentialCustomer$ | async) === false) {
              <div
                class="trade buy cursor-pointer mr-2 ml-0"
                [title]="'watchlist.actions.buy' | transloco"
                [routerLink]="commonRoutes.postlogin.buyAndSell"
                [queryParams]="{
                  isin: item.isin,
                  direction: 'buy',
                }"
              >
                K
              </div>
            }
            <div class="d-flex flex-column align-items-end cursor-pointer">
              <div class="sorter-after-flat" (click)="handleUp()"></div>
              <div class="sorter-after-flat sorter-after-flat--down" (click)="handleDown()"></div>
            </div>
          </div>
        </div>
      </td>
    }
  }
}
